/** Intl.PluralRules polyfill for Safari 9 (just to stop it from breaking) */

class PluralRules {
  static supportedLocalesOf(locales) {
    return [];
  }

  resolvedOptions() {
    return {};
  }

  select(number) {
    return "other";
  }
}

if (typeof Intl === "undefined") {
  if (typeof window !== "undefined") {
    window.Intl = { PluralRules };
  } else {
    this.Intl = { PluralRules };
  }
} else if (!Intl.PluralRules) {
  Intl.PluralRules = PluralRules;
}
